import '@mantine/core/styles.css';

import { MantineProvider } from '@mantine/core';
import { theme } from './theme';
import { FinixEnvironmentContext } from './FinixEnvironmentContext';

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MantineProvider defaultColorScheme='light' theme={theme}>
      <FinixEnvironmentContext.Provider
        value={import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT ?? 'sandbox'}
      >
        {children}
      </FinixEnvironmentContext.Provider>
    </MantineProvider>
  );
};

export default AppProvider;
